import React from "react";
import Chart from "react-apexcharts";

import withChart from "./withChart";

function LineChart(props) {
  const { options, series } = props;
  
  return (
    <Chart
      type="line"
      options={options}
      series={series}
      height="600px"
    />
  );
}


export default withChart(LineChart);